import { Grid, Typography } from '@mui/material';

export interface BakeasyEmptyMsg {
  message: string;
}
function BakeasyEmptyMsg(props: BakeasyEmptyMsg) {
  return (
    <Grid style={{ marginTop: 20, height: 50, textAlign: 'center' }}>
      <Typography>{props.message}</Typography>
    </Grid>
  );
}

export default BakeasyEmptyMsg;
